import React from 'react';
import PhaseNavigation from '../PhaseNavigation';

/**
 * Sidebar - Contains phase navigation.
 * Expand/collapse width is handled by the parent <aside> in DashboardLayout;
 * this component just renders the nav content that fills it.
 */
const Sidebar = () => {
  return (
    <div className="h-full" data-testid="sidebar">
      <PhaseNavigation />
    </div>
  );
};

export default Sidebar;
